// https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/btoa

import { logError } from "@glide/support";
import { exceptionToString } from "@glideapps/ts-necessities";

// Convert a Uint8Array or Uint16Array to a string,
// with each value in the array being interpreted as a unicode code point.
// Adapted from Uint8ToString() in https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
function arrayToString(array: Uint8Array | Uint16Array) {
    // We can't use String.fromCharCode(...array) as this fails when array is too large.
    // Instead, we do it in chunks then join them.
    const CHUNK_SIZE = 0x8000;
    const chunks = [];
    for (let i = 0; i < array.length; i += CHUNK_SIZE) {
        chunks.push(String.fromCharCode(...array.subarray(i, i + CHUNK_SIZE)));
    }
    return chunks.join("");
}

// convert a Unicode string to a byte string, with each 16-bit unit taking two bytes
function utf16ToBinary(s: string): string {
    const codeUnits = new Uint16Array(s.length);
    for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = s.charCodeAt(i);
    }
    return arrayToString(new Uint8Array(codeUnits.buffer));
}

function utf16FromBinary(binary: string): string {
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return arrayToString(new Uint16Array(bytes.buffer));
}

const b64Encoder = btoa;

export const base64Encode = b64Encoder;

export function base64EncodeUTF16String(s: string): string {
    return b64Encoder(utf16ToBinary(s));
}

export function base64EncodeBytesString(s: string): string {
    return b64Encoder(s);
}

const b64Decoder = atob;

export function base64DecodeUTF16String(s: string): string | undefined {
    try {
        return utf16FromBinary(b64Decoder(s));
    } catch (e: unknown) {
        logError("Error decoding base64 string", exceptionToString(e));
        return undefined;
    }
}

export function base64DecodeBytesString(s: string): string | undefined {
    try {
        return b64Decoder(s);
    } catch (e: unknown) {
        logError("Error decoding base64 string", exceptionToString(e));
        return undefined;
    }
}
